import React, { useRef, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import CommonTable from "../../components/tables/CommonTable";
import api from "../../api";
import NotyfContext from "../../contexts/NotyfContext";

const AccessProfilesButton = ({ report, children }) => {
  const [showModal, setShowModal] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const accessProfilesTableRef = useRef();
  const notify = useContext(NotyfContext);

  const columns = [
    {
      Header: "Name",
      accessor: "permissionName",
      type: "link",
      link: "/accessprofiles/edit",
      stateId: "id",
    },
    {
      Header: "",
      accessor: "id",
      Cell: (cell) => {
        return cell.row.original.allReports ? (
          <div className="d-flex justify-content-end">
            <Button className="me-2" variant="danger" disabled>
              (All Reports)
            </Button>
          </div>
        ) : (
          <div className="d-flex justify-content-end">
            <Button
              className="me-2"
              variant={"danger"}
              onClick={() => {
                handleRemove(cell.row.original);
              }}
            >
              Remove
            </Button>
          </div>
        );
      },
      disableSortBy: true,
    },
  ];

  const addColumns = [
    {
      Header: "Profile Name",
      accessor: "permissionName",
      type: "link",
      link: "/accessprofiles/edit",
      stateId: "id",
    },
    {
      Header: "",
      accessor: "id",
      Cell: (cell) => (
        <div className="d-flex justify-content-end">
          <Button
            className="me-2"
            variant={"success"}
            onClick={() => {
              handleAdd(cell.row.original);
            }}
          >
            Add
          </Button>
        </div>
      ),
      disableSortBy: true,
    },
  ];

  const handleClick = (e) => {
    setShowModal(true);
  };
  const handleClose = (e) => {
    setShowModal(false);
  };

  const handleAddToExisting = (e) => {
    setShowAdd(true);
  };

  const handleCancel = (e) => {
    setShowAdd(false);
  };

  const handleAdd = (accessProfile) => {
    api
      .post(`accessprofiles/${accessProfile.id}/reports/link/${report.id}`)
      .then((resLink) => {
        notify.open({
          type: "success",
          message: "Changes Saved",
        });
        setShowAdd(false);
        // accessProfilesTableRef.current.updateTable(1);
      });
  };

  const handleRemove = (accessProfile) => {
    setShowConfirmRemove(accessProfile);
  };
  // const onAddToExisting = (data) => {};

  const handleRemoveConfirmed = () => {
    if (showConfirmRemove && showConfirmRemove.id) {
      api
        .post(
          `accessprofiles/${showConfirmRemove.id}/reports/unlink/${report.id}`
        )
        .then((resLink) => {
          accessProfilesTableRef.current.updateTable(1);
          setShowConfirmRemove(null);
          notify.open({
            type: "success",
            message: "Changes Saved",
          });
        });
    }
  };

  return (
    <React.Fragment>
      <Button className="mx-1 py-0" variant="secondary" onClick={handleClick}>
        Access Profiles
      </Button>
      <Modal size="lg" show={showModal} onHide={handleClose}>
        <ModalHeader closeButton>
          <div className="d-flex justify-content-between w-100 pe-5">
            <ModalTitle>{`Access Profiles for '${report.name}' report`}</ModalTitle>
            <Button hidden={showAdd} onClick={handleAddToExisting}>
              Add to Existing
            </Button>
          </div>
        </ModalHeader>
        <ModalBody>
          {!showAdd && (
            <CommonTable
              ref={accessProfilesTableRef}
              apiName="accessprofiles"
              columns={columns}
              parentId={`report:${report.id}`}
            />
          )}
          {showAdd && (
            <CommonTable
              apiName="accessprofiles"
              columns={addColumns}
              parentId={`report:!${report.id}`}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button hidden={showAdd} onClick={handleClose} variant="secondary">
            Close
          </Button>
          <Button hidden={!showAdd} onClick={handleCancel} variant="secondary">
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        show={showConfirmRemove}
        onHide={() => setShowConfirmRemove(null)}
        centered={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Please Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you wish to remove this Access Profile?</p>
          <div>
            <hr></hr>
            <p>
              Removing the Report from the Access Profile will also remove
              associated Scheduled Reports
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant={"danger"} onClick={() => handleRemoveConfirmed()}>
            Remove
          </Button>
          <Button
            variant={"secondary"}
            onClick={() => setShowConfirmRemove(null)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default AccessProfilesButton;
